import { useQuery } from '@tanstack/react-query'
import { getInvoices, InvoiceType } from 'api/payment'
import { useAuthContext } from 'components/auth'
import { invoicesKey } from './keys'

interface UseInvoices {
  type: InvoiceType
  startDate?: Date
  endDate?: Date
}

export function useInvoices(options: UseInvoices) {
  const { type, startDate, endDate } = options
  const { company } = useAuthContext()

  return useQuery({
    queryKey: invoicesKey(type, startDate, endDate),
    queryFn: () => {
      if (!company?.id) {
        throw new Error('Company ID not found')
      }
      return getInvoices({ companyId: company.id, type, startDate, endDate })
    },
    enabled: Boolean(company?.id),
  })
}
